import { render, staticRenderFns } from "./MessageSettingsTab.vue?vue&type=template&id=7f686269&scoped=true&"
import script from "./MessageSettingsTab.vue?vue&type=script&lang=js&"
export * from "./MessageSettingsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f686269",
  null
  
)

export default component.exports